import { StyledFarmCard } from './style';
import { useIntl } from 'react-intl';
import { FarmData } from '../../types/FarmData';
import { FallbackImage } from '../UploadImage/fallBack/FallBackImage';
import useMarketType from '../../utils/useMarketType';
import { publicPath } from 'enums/publicRoutes';
import { useNavigate } from 'react-router-dom';

export interface FarmProps {
  farm?: FarmData;
  className?: string;
  isFarmList?: boolean;
  isFarmMap?: boolean;
  plainLogoUrl?: string;
  hoverable?: boolean;
}

export const FarmCard = ({
  farm,
  className,
  isFarmList = false,
  isFarmMap = false,
  plainLogoUrl,
  hoverable,
}: FarmProps) => {
  const { isEmarket } = useMarketType();

  const farmCardClassNames = ['farm-card'];
  const navigate = useNavigate();

  if (className) {
    farmCardClassNames.push(className);
  }

  if (isFarmList) {
    farmCardClassNames.push('farm-list-card');
  }

  if (isFarmMap) {
    farmCardClassNames.push('farm-map-card');
  }

  const intl = useIntl();

  const coverImg = (
    <FallbackImage
      src={plainLogoUrl ?? farm?.logo ?? farm?.images?.[0]?.url_original}
      type="FarmCard"
      preview={false}
    />
  );

  const address =
    farm?.actual_full_address ?? farm?.registered_full_address ?? '';

  const uniqueMarks = farm?.quality_marks?.filter(
    (q, i, arr) => arr.findIndex((x) => x.id === q.id) === i
  );

  return (
    <StyledFarmCard
      className={farmCardClassNames.join(' ')}
      cover={coverImg}
      onClick={() => navigate(publicPath.farm(farm?.slug, farm?.id))}
      hoverable={hoverable}
    >
      <div className={'container'}>
        <div className={'farm-name'}>{farm?.brand ?? farm?.name}</div>
        <div className={'address-farm'}>
          <div className={'address'}>{address}</div>
        </div>
        <div className={'qmarks-wrapper'}>
          <div className={'qmarks-url'}>
            <div className="qmarks">
              {uniqueMarks?.map((qmark) => (
                <FallbackImage
                  src={qmark.logo || ''}
                  type="notFound"
                  preview={false}
                  key={qmark.id}
                />
              ))}
            </div>
            <div className={'url-to'}>
              <a
                href={
                  isEmarket
                    ? publicPath.farm(farm?.slug, farm?.id)
                    : publicPath.wholesaleFarm(farm?.slug, farm?.id)
                }
              >
                {intl.formatMessage({ id: 'farm_card.view' })}
              </a>
              <div className={'rect-angle-wrap'}>
                <div className={'rect'}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledFarmCard>
  );
};
